<template>
  <transition name="fade">
    <div class="ui-toast" v-show="showToast">{{ toastDesc }}</div>
  </transition>
</template>

<script>
import { mapGetters } from "vuex"
export default {
  name: "uiToast",
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      showToast: "toast/showToast",
      toastDesc: "toast/toastDesc"
    })
  }
}
</script>

<style lang="scss" scoped>
.ui-toast {
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 99999;
  transform: translate3d(-50%, -50%, 0);
  background: rgba(0, 0, 0, 0.8);
  border-radius: 0.2rem;
  font-family: PingFangSC-Regular;
  font-size: 0.32rem;
  color: #ffffff;
  text-align: center;
  padding: 0.38rem 0.48rem;
  max-width: 6rem;
  min-width: 5rem;
  text-overflow: ellipsis;
  white-space: wrap;
  overflow: hidden;
  line-height: 0.44rem;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s ease-in-out;
}
.fade-enter-to,
.fade-leave {
  opacity: 1;
}
</style>
